<template>
  <div>
    <div class="md-mx3 mx2">
    <headline customClass="galleries-headline" link="/" headline="Fotoalben" />
    </div>
    <div class="galleries-wrapper md-mx3 flex-wrap border-box">
      <gallery-card v-for="gallery in galleries" 
        :key="gallery.id"
        :galleryid="gallery.id"
        :title="gallery.name"
        :thumbnail="gallery.thumbnaillink"
        :created_at="gallery.created_at"
      />
    </div>
  </div>
</template>
<script>
import { EventBus } from '../event-bus.js';
import GalleryCard from './GalleryCard.vue';
import Headline from './Headline.vue';
import axios from 'axios';
export default {
  name: "GalleryOverview",
  data() {
    return {
      session: {},
      galleries: []
    };
  },
  components: {
    'gallery-card': GalleryCard,
    'headline': Headline,
  },
  created() {
    EventBus.$on('loginSuccessful', (payload) => {
      this.session = payload.session;
      this.loginStatus = true;
    });
    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      this.session = payload.session;

      this.loadGalleriesList();
    });
  },
  mounted(){
    EventBus.$emit('loginCheck', {});
    this.loadGalleriesList()
  },
  methods:{
    loadGalleriesList(){
      let that = this;
        let url =  'https://bilder.nachtschicht-schortens.de/public-api/get/galleries/json';
        axios.post(url)
        .then(response => {
          that.galleries = response.data.data.reverse() 
          
        })
        .catch(function (error) {
          console.log(error);
        });
      }
  }
}
</script>
<style>

</style>
